import { registerComponent } from '../registry';
import { COMPONENT_TYPES } from '../../../constants';
import ProductListComponent from './ProductList.component';
import ProductListEditor from './ProductList.editor';
import ProductListProperties from './ProductList.properties';

// 컴포넌트 내보내기
export { default as ProductListComponent } from './ProductList.component';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.PRODUCT_LIST,
  component: ProductListComponent,
  editorComponent: ProductListEditor,
  properties: ProductListProperties,
  name: '상품 목록',
  category: 'ecommerce',
  icon: '🛍️',
  defaultProps: {
    componentProps: {
      order: '',
      lg: 12,
      className: 'padding-tb-40',
      itemsPerRow: 4,
      categoryId: '',
      excludeIndexes: [],
      showStock: false,
      include_product_ids: [],
      exclude_product_ids: [],
      include_category_ids: [],
      exclude_category_ids: [],
      itemsPerPage: 20
    },
    style: {
      width: '100%',
      padding: '0px',
      boxSizing: 'border-box',
    }
  }
}); 